<template>
  <div id="Rahmen">
    <div id="Titel">
      <span id="TitelText" v-html="title" /><br>
      <span id="Datum">{{Datum}}</span>
    </div>
    <div v-if="text !== null" id="Text">
      <p><span v-html="TextEnter" /></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Nachricht',
    props: {
      title: {type: String, default: null},
      date: {type: String, default: null},
      text: {type: String, default: null}
    },

    data () {
      return {

      }
    },

    computed: {
      Datum: function () {
        var Datum = new Date(this.date)
        var Wochentage = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
        var Monate = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
        return Wochentage[Datum.getDay()] + ', ' + Datum.getDate() + '. ' + Monate[Datum.getMonth()] + ' ' + (Datum.getYear() + 1900)
      },

      TextEnter: function () {
        var Text = this.text.toString()
        while (Text.indexOf('\n\n') !== -1) {
          Text = Text.replace('\n\n', '</p><p>')
        }
        while (Text.indexOf('\n') !== -1) {
          Text = Text.replace('\n', '<br>')
        }
        return Text
      }
    }
  }
</script>

<style scoped>

  #Rahmen {
    margin-top: 0em;
    margin-bottom: 0.5em;
  }

  #Titel {
    user-select: none;
    background-color: #98cb00;
    color: #FFFFFF;
    padding: 0.5em;
  }

  #TitelText {
    font-weight: bold;
    font-size: 1.2em;
  }

  #Datum {
    font-style: italic;
    font-size: 0.8em;
  }

  #Text {
    border: 2.5px solid #98cb00;
    margin-bottom: 1em;
    padding-left: 0.5em;
    padding-right: 0.5em;
  }

</style>



// WEBPACK FOOTER //
// src/components/Nachricht.vue